import React, { Component } from 'react';

import { Form, InputNumber, Row ,Col ,Slider } from 'antd';

const FormItem = Form.Item;

class IntegerSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };
    }

    onChange = value => {
        this.onProgressChange(value);
    };

    onProgressChange(data){
        this.props.onProgressChange(data)
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    render() {
        const { label} = this.props;
        const { value } = this.state;
        return (
            <Row style={{marginLeft:20}}>
                <FormItem label={label}>
                <Col span={16}>
                  <Slider
                    min={0}
                    max={100}
                    onChange={this.onChange}
                    value = {value}
                  />
                </Col>
                <Col span={2}>
                  <InputNumber
                    min={0}
                    max={100}
                    style={{ marginLeft: 16 }}
                    value={value}
                    onChange={this.onChange}
                  />
                </Col>
                </FormItem>
              </Row>
        );
    }
}

export default IntegerSlider;